import { useMemo } from 'react';
import { EVENTS, CAT, CALENDAR_DATA_UPDATED } from '../../data/calendarEvents';
import { fmtEventTime } from '../../utils/fmt';
import HomeModule from './HomeModule';

/* Közelgő események (3a): 3–5 tétel a kézi naptárból, pontos idővel
   Europe/Budapest időzónában, fontosság-jelöléssel; konszenzus, ha van az adatban. */

const SHOW = 4;
export function eventInstant(e) {
  const m = /^(\d{2}):(\d{2})/.exec(e.time || '');
  return Date.parse(`${e.date}T${m ? `${m[1]}:${m[2]}` : '00:00'}:00Z`);
}
const IMPACT = { high: ['●●●', 'Nagy hatású'], medium: ['●●○', 'Közepes hatású'], low: ['●○○', 'Kis hatású'] };

export default function UpcomingEvents({ user }) {
  const items = useMemo(() => {
    const now = Date.now();
    return EVENTS.map(e => ({ ...e, at: eventInstant(e) }))
      .filter(e => e.at >= now - 30 * 60e3 && (e.impact === 'high' || e.impact === 'medium'))
      .sort((a, b) => a.at - b.at)
      .slice(0, SHOW);
  }, []);
  return (
    <HomeModule id="next_events" title="Közelgő események" user={user}
      source="makronaptár (kézzel összeállított)" note={`Ellenőrizve: ${CALENDAR_DATA_UPDATED.replace(/-/g, '. ')}.`}
      className="hev">
      {items.length === 0 && <div className="hev-empty">Nincs közelgő esemény a naptárban.</div>}
      {items.map(e => {
        const [dots, impTitle] = IMPACT[e.impact] || IMPACT.low;
        return (
          <div key={e.id || `${e.date}-${e.event}`} className="hev-row">
            <div className="hev-top">
              <span className="hev-when num">{fmtEventTime(e.at)}</span>
              <span className={`hev-imp hev-imp-${e.impact}`} title={impTitle} aria-label={impTitle}>{dots}</span>
            </div>
            <div className="hev-name">{CAT[e.category]?.icon ?? '📅'} {e.event}</div>
            {e.forecast && <div className="hev-cons">Várakozás: {e.forecast}{e.previous ? ` · előző: ${e.previous}` : ''}</div>}
          </div>
        );
      })}
    </HomeModule>
  );
}
